import { uniqBy } from "lodash-es";

import type { DictionaryMethod, SearchLanguage } from "@/types";

export function getSourceLanguage(method: DictionaryMethod): SearchLanguage | undefined {
  if (method.sourceLanguageCode === "") {
    return;
  }

  return {
    code: method.sourceLanguageCode,
    name: method.sourceLanguage
  };
}

export function getTargetLanguage(method: DictionaryMethod): SearchLanguage | undefined {
  if (method.targetLanguageCode === "") {
    return;
  }

  return {
    code: method.targetLanguageCode,
    name: method.targetLanguage
  };
}

export function getLanguages(methods: DictionaryMethod[]): SearchLanguage[] {
  return uniqBy(
    methods.reduce((languages: SearchLanguage[], method) => {
      languages.push(
        { code: method.sourceLanguageCode, name: method.sourceLanguage },
        { code: method.targetLanguageCode, name: method.targetLanguage }
      );

      return languages;
    }, []),
    "code"
  );
}
